import {BodyStyleChips} from '../../kit/components/BodyStyleChips';
import {EngineSpecsGroup} from '../../kit/groups/EngineSpecsGroup';
import {FuelGroup} from '../../kit/groups/FuelGroup';
import {isTrailerOrSemitrailer} from '../../kit/utils/isTrailerOrSemitrailer';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function EngineBasicsSubSection() {
  return (
    <VFKit.SubSection data-testid="engine-basics">
      <VFKit.ShowWhen name="type" condition={(type) => type?.at(0) !== 'VEHICLETYPE_OTHER'}>
        <BodyStyleChips />
      </VFKit.ShowWhen>

      <VFKit.ShowWhen
        name="type"
        condition={(type) => !isTrailerOrSemitrailer(type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR')}
      >
        <FuelGroup />

        <VFKit.Group data-testid="transmission-drive" columns={[1, 2]}>
          <VFKit.TransmissionChips />
          <VFKit.DriveChips />
        </VFKit.Group>

        <VFKit.Group data-testid="engine-specs" columns={[1, 2, 4]}>
          <EngineSpecsGroup />
          <VFKit.SimpleNumericField name="gearCount" />
        </VFKit.Group>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
